<template>
	<c-dialog ref="dialog" mode="slide" width="500" mask-close @close="dialogFormEditConfirm($refs.form, arguments)" @resolve="submitHandle">
		<c-tips>单个业务的自定义字段最多可创建{{freeEdition ? systemConfig.free_field_count : systemConfig.vip_field_count}}个</c-tips>

		<c-form ref="form" unit-width="100%" vertical>
			<c-input type="hidden" name="id"></c-input>
			<c-form-item label="字段名称" required>
				<c-input name="field_title"></c-input>
			</c-form-item>

			<c-form ref="config" name="config_json" link-parent>
				<c-form-item label="字段类型" required>
					<c-select v-model="fieldType" name="type" :options="typeOptions" :disabled="editState" :clear="false" @change="updateDefaultField('type')"></c-select>
				</c-form-item>

				<c-form-item v-if="fieldType == 'option'" label="设置选项">
					<template #handle>
						<c-link @click="$refs.optionList.push({value: ''})">添加选项</c-link>
					</template>

					<c-table ref="optionList" :data="optionList" border>
						<c-table-column
							type="drag"
							@handle="updateOptionDefaultOptions"
						></c-table-column>

						<c-table-column
							label="选项内容"
							width="240"
						>
							<template #default="{data}">
								<c-input v-model="data.value" @change="updateOptionDefaultOptions"></c-input>
							</template>
						</c-table-column>

						<c-table-column
							label="操作"
							width="40"
							align-center
						>
							<template #default="row">
								<c-link style="color: #f55;" @click="row.remove(); updateOptionDefaultOptions()">删除</c-link>
							</template>
						</c-table-column>
					</c-table>
				</c-form-item>

				<c-form-item v-show="fieldType" label="字段属性">
					<c-checkbox-group v-model="fieldAttr" name="attr" class="sub">
						<div class="sub-item">
							<c-checkbox value="required" :disabled="fieldAttr.includes('readonly')">必填</c-checkbox>
						</div>
						<div v-if="readonlyAttr" class="sub-item">
							<c-checkbox value="readonly" :disabled="fieldAttr.includes('required')">只读</c-checkbox>
						</div>
						<div v-if="fieldType == 'text'" class="sub-item">
							<c-checkbox value="textarea">多行</c-checkbox>
						</div>
						<div v-if="fieldType == 'number'" class="sub-item flex-center-cross">
							<div class="sub-item-option">
								<c-checkbox value="decimal">小数位数</c-checkbox>
							</div>
							<c-input v-show="fieldAttr.includes('decimal')" v-model="numberDecimal" class="sub-unit" type="stepper" name="decimal" range="1,5" align-center :clear="false" placeholder="请输入" @blur="numberDecimal = numberDecimal || 0"></c-input>
						</div>
						<div v-if="multipleAttr" class="sub-item">
							<c-checkbox value="multiple" @change="multipleHandle">多选</c-checkbox>
						</div>
						<div v-if="fieldType == 'text'" class="sub-item">
							<c-checkbox value="scan">扫码输入</c-checkbox>
						</div>
						<div v-if="fieldType == 'option'" class="sub-item flex-center-cross">
							<c-checkbox value="add">允许用户添加选项</c-checkbox>
							<c-tooltip width="200" position="top" tip="当用户搜索的选项在备选列表中不存在时，允许用户直接创建该选项"></c-tooltip>
						</div>
					</c-checkbox-group>
				</c-form-item>

				<c-form-item v-if="fieldType == 'time'" label="显示精度">
					<c-select name="format" :options="timeFormatOptions" :clear="false"></c-select>
				</c-form-item>

				<c-form-item v-if="fieldType == 'option'" label="显示方式">
					<c-select v-model="optionMode" name="mode" :options="optionModeOptions" :clear="false"></c-select>
				</c-form-item>

				<c-form-item v-if="fieldType == 'file'" label="文件类型" tip="不选表示不限制文件类型">
					<c-checkbox-group name="suffix">
						<c-checkbox v-for="(item, i) in fileSuffixOptions" :key="i" :value="item.value">{{item.name}}</c-checkbox>
					</c-checkbox-group>
				</c-form-item>

				<c-form v-show="fieldType" ref="default" name="default" link-parent>
					<c-form-item label="默认值">
						<c-radio-group v-model="defaultType" name="type" class="sub">
							<div class="sub-item">
								<div class="sub-item-option">
									<c-radio value="0">无</c-radio>
								</div>
							</div>
							<div v-if="defaultConfig.value" class="sub-item flex-center-cross">
								<div class="sub-item-option">
									<c-radio value="1">自定义</c-radio>
								</div>
								<template v-if="defaultType == 1">
									<c-input v-if="fieldType == 'text'" class="sub-unit" name="value" :clear="false" placeholder="请输入"></c-input>
									<c-input v-if="fieldType == 'number'" class="sub-unit" type="stepper" name="value" align-center :decimal="fieldAttr.includes('decimal') ? numberDecimal : 0" :clear="false" placeholder="请输入"></c-input>
									<c-select v-if="fieldType == 'time'" class="sub-unit" name="value" :options="timeDefaultOptions" :clear="false" placeholder="请选择"></c-select>
									<c-select v-if="fieldType == 'option'" ref="optionDefaultOptions" class="sub-unit" name="value" :options="optionDefaultOptions" :multiple="fieldAttr.includes('multiple')" :clear="false" placeholder="请选择"></c-select>
								</template>
							</div>
							<div v-show="defaultSourceList.length" class="sub-item flex">
								<div class="sub-item-option">
									<c-radio value="2">关联对象</c-radio>
								</div>
								<div v-if="defaultType == 2" class="flex-grow sub-area flex-column">
									<div>
										<label>业务对象</label>
										<c-select class="sub-unit flex-grow" name="source" :options="defaultSourceList" :clear="false" placeholder="请选择所属业务" @change="updateDefaultField('source', $event)"></c-select>
									</div>
									
									<div>
										<div class="flex-baseline">
											<label>关联字段</label>
											<span>(以下字段的值将自动填充到当前字段)</span>
										</div>
										<c-select class="sub-unit flex-grow" name="field" :options="defaultFieldListForType" :clear="false" placeholder="请选择业务字段"></c-select>
									</div>
								</div>
							</div>
						</c-radio-group>
					</c-form-item>
				</c-form>

				<c-form-item v-if="fieldPlaceholder" label="引导文字">
					<c-input name="placeholder"></c-input>
				</c-form-item>
				
				<c-form-item label="提示说明">
					<c-input name="tip"></c-input>
				</c-form-item>
			</c-form>
		</c-form>
	</c-dialog>
</template>

<script>
	import {mapState, mapGetters} from 'vuex'
	
	export default {
		props: {
			type: Number
		},

		data() {
			return {
				editState: false,

				fieldType: '',
				typeOptions: [{
					name: '文本',
					value: 'text'
				}, {
					name: '数字',
					value: 'number'
				}, {
					name: '时间',
					value: 'time'
				}, {
					name: '选项',
					value: 'option'
				}, {
					name: '附件',
					value: 'file'
				}, {
					name: '图片',
					value: 'image'
				}],

				fieldAttr: [],

				numberDecimal: 0,

				timeFormatOptions: [{
					name: '年-月-日',
					value: 'yyyy-MM-dd|date'
				}, {
					name: '年-月-日 时',
					value: 'yyyy-MM-dd hh|datetime|hour'
				}, {
					name: '年-月-日 时:分',
					value: 'yyyy-MM-dd hh:mm|datetime|min'
				}, {
					name: '年-月-日 时:分:秒',
					value: 'yyyy-MM-dd hh:mm:ss|datetime|sec'
				}, {
					name: '时:分:秒',
					value: 'hh:mm:ss|time|sec'
				}],

				optionList: [],
				optionMode: '',
				optionModeOptions: [{
					name: '下拉选择',
					value: 'select'
				}, {
					name: '平铺',
					value: 'option'
				}],

				fileSuffixOptions: [{
					name: '图片',
					value: 'image'
				}, {
					name: '视频',
					value: 'mp4'
				}, {
					name: 'word',
					value: 'word'
				}, {
					name: 'excel',
					value: 'excel'
				}, {
					name: 'ppt',
					value: 'ppt'
				}, {
					name: 'pdf',
					value: 'pdf'
				}, {
					name: '压缩包',
					value: 'zip'
				}],

				defaultType: 0,
				timeDefaultOptions: [{
					name: '当前时间',
					value: 'now'
				}],
				optionDefaultOptions: [],
				defaultSourceList: [],
				defaultFieldList: [],
				defaultFieldListForType: []
			}
		},

		computed: {
			...mapState(['systemConfig']),
			...mapGetters(['freeEdition']),

			readonlyAttr() {
				return ['text', 'number', 'time'].includes(this.fieldType);
			},

			multipleAttr() {
				return ['option', 'file', 'image'].includes(this.fieldType);
			},

			defaultConfig() {
				return {
					value: !['file', 'image'].includes(this.fieldType)
				}
			},

			fieldPlaceholder() {
				return ['text', 'number', 'time', 'option'].includes(this.fieldType) || (this.fieldType == 'option' && this.optionMode == 'select');
			}
		},

		watch: {
			fieldType(val) {
				this.$nextTick(() => {
					this.$refs.config.set({
						attr: [],
						decimal: '',
						format: val == 'time' ? 'yyyy-MM-dd|date' : '',
						mode: val == 'option' ? 'select' : '',
						suffix: [],
						default: {
							type: '0'
						}
					})
				})
			}
		},

		methods: {
			async open(data) {
				this.editState = !!data;
				if (!this.editState && !(await this.checkDataCount('SYSTEM_FIELD', this.type)).data) return;
				this.optionList = [];
				this.defaultSourceList = [];
				this.defaultFieldList = [];
				this.defaultFieldListForType = [];
				this.updateDefaultSource();
				this.$refs.form.clear();
				if (data) {
					if (data.config_json.default && data.config_json.default.type == 2) {
						this.updateDefaultField('source', {
							value: data.config_json.default.source
						});
					}

					this.$refs.form.set(data);
					this.$nextTick(() => {
						if (data.config_json.type == 'option') {
							this.optionList = data.config_json.options || [];
							this.$nextTick(this.updateOptionDefaultOptions);
						}
						this.$refs.form.set(data);
						this.$nextTick(() => {
							this.$refs.form.set(data);
							this.$nextTick(() => {
								this.$refs.form.set(data);
							});
						});
					});
				} else {
					this.$refs.config.set({
						default: {
							type: '0'
						}
					});
				}
				this.$refs.dialog.open({
					title: data ? '编辑字段' : '添加新字段'
				});
			},
			
			multipleHandle() {
				this.$nextTick(() => {
					this.$refs.optionDefaultOptions && this.$refs.optionDefaultOptions.set('');
				});
			},

			updateOptionDefaultOptions() {
				this.optionDefaultOptions = this.$refs.optionList.getData().map(item => {
					return {
						name: item.value,
						value: item.value
					}
				}).filter(item => item.value.trim());
			},

			updateDefaultSource() {
				this.request({
					url: '/sys_field/ref/datasource/list',
					data: {
						work_type_id: this.type
					},
					success: data => {
						this.defaultSourceList = data.map(item => {
							return {
								name: item.name,
								value: item.ref_work_type_id
							}
						});
					}
				});
			},

			updateDefaultField(scene, data) {
				if (scene == 'source') {
					this.request({
						url: '/sys_field/list',
						data: {
							work_type_id: data.value
						},
						success: data => {
							this.defaultFieldList = data.map(item => {
								return {
									name: item.field_title,
									value: item.id,
									config: item.config_json
								}
							});
							this.updateDefaultField('type');
						}
					});
				} else {
					this.defaultFieldListForType = this.defaultFieldList.filter(item => {
						if (this.fieldType == 'text') {
							return ['text', 'number', 'option'].includes(item.config.type);
						} else if (this.fieldType == 'file') {
							return ['file', 'image'].includes(item.config.type);
						} else {
							return item.config.type == this.fieldType;
						}
					});
				}
			},

			submitHandle(stop, next) {
				stop();
				this.$refs.form.submit({
					url: this.editState ? '/sys_field/edit' : '/sys_field/add',
					rule: {
						field_title: '请填写字段名称',
						'config_json.type': '请选择字段类型'
					},
					dataFormatter: data => {
						if (data.config_json.type == 'option') {
							data.config_json.options = this.$refs.optionList.getData().map(item => {
								return {
									name: item.value,
									value: item.value
								}
							}).filter(item => item.value.trim());
						}
						if (
							!data.config_json.default
							|| (data.config_json.default.type == 1 && !data.config_json.default.value.length)
							|| (data.config_json.default.type == 2 && (!data.config_json.default.source || !data.config_json.default.field))
						) {
							data.config_json.default = {
								type: 0
							};
						}
						data.config_json = JSON.stringify(data.config_json);
						data.work_type_id = this.type;
						return data;
					},
					success: () => {
						next();
						this.$message({
							message: '提交成功'
						});
						this.$emit('resolve');
					}
				})
			}
		}
	}
</script>

<style lang="stylus" scoped>
	.sub {
		display: flex;
		flex-direction: column;

		&-item {
			gap: 10px;
			min-height: 28px;

			&:nth-child(n+2) {
				margin-top: 4px;
			}

			&-option {
				width: 100px;
				height: 26px;
			}
		}

		&-area {
			gap: 5px;
			padding: 5px 20px 15px;
			background: #F9F9F9;

			label {
				line-height: 34px;
				font-size: 14px;
				color: #666;
			}

			span {
				margin-left: 6px;
				font-size: 12px;
				color: #666;
			}

			.sub-unit {
				width: 100%;
				height: 36px;
			}
		}

		&-unit {
			width: 150px;
			height: 28px;

			>>> .c-select-tag-item {
				line-height: 18px;
			}
		}
	}
</style>